export default __webpack_public_path__ + "static/media/icon06.e7da7b22.png";